import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const Landing = (props) => (
    <div className="reg-page">
        <div className="bound-box">
            <h1>Welcome to HackMakers!</h1>
            <p><b>##Digitaldefence Hack 2020</b> is the next upcoming hackathon. </p><br/>
            <p><Link to={ROUTES.DASHBOARD} className="button">ACCESS THE HACKERSPACE</Link></p><br/>
            <p><a target="_blank" rel="noopener noreferrer" href="https://hackmakers.com/digitaldefencehack/ " className="button">HACKATHON HOMEPAGE</a></p>
        </div>
    </div>
)

export default withRouter(Landing);
